<template>
  <div>
    <table
      class="table table-hover table-sm table-bordered table-striped"
    >
      <thead>
      <tr>
        <th>№</th>
        <th>Доставка</th>
        <th>Клиент</th>
        <th>Препараты</th>
        <th>Общая сумма</th>
        <!--        <th>Ф. Надб</th>-->
        <!--        <th>З/П без фикс</th>-->
        <th>З/П курьера</th>
        <th>Сумма к сдаче</th>
        <th>Адрес</th>
        <th>Курьер</th>
      </tr>
      </thead>
      <tbody>
      <tr class="total_tr">
        <td colspan="4">ИТОГО</td>
        <td>{{ totalFigures.price }}</td>
        <td>{{ totalFigures.salary }}</td>
        <td>{{ totalFigures.pass }}</td>
        <td colspan="10"></td>
      </tr>
      <tr v-for="(order, index) in orders" :key="index">
        <td class="phone_num">
          {{ mixinPrintOrderNum(order.id) }}
          {{ moment(order.report_date, "DD.MM.YYYY") }}
          <div v-if="order.sub_status === subStatus_closedByTablet">
            <i class="icon-fa icon-fa-tablet"></i>
          </div>
        </td>
        <td>
          <p>{{
              order.city_id === 0 ? 'Почта' : $AllCities[order.city_id] && $AllCities[order.city_id].name || 'Не определен'
            }}</p>
          <p>{{ order.project_label }}</p>
          {{ moment(order.report_date, "HH:mm:ss") }}
        </td>
        <td>
          <p>{{ order.client_name ?? "не определен" }}</p>
          <p
            v-for="(p, ind) in order.phones"
            :key="ind"
            class="phone_num"
          >
            {{ mixinPrintPhone(p.phone.full_phone) }}
          </p>
        </td>
        <td>
          <div v-for="(drug, ind) in order.details" :key="ind">
            {{ drug.drug.title }} ({{ drug.drug_id }}) - {{ drug.qty / (drug.pack_set || 1) }}
            <div class="alert alert-danger m-0 p-1 mb-1" v-if="drug.pack_set !== 1">
              {{ drug.qty / (drug.pack_set || 1) }} комплект ({{ drug.qty }} зав.упак.)
            </div>
            <div class="flex pack_details_block">
              <template v-if="drug.drug.holod">
                <div>
                  <!--                          <i class="icon icon-snowflake"/>-->
                  <i
                    v-tooltip="{
                        content: 'Требуется хладоген',
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        offset: 20,
                        delay: {
                          show: 500,
                          hide: 300
                        }
                      }"
                    class="icon icon-snowflake pointer"
                  ></i>
                </div>
              </template>
              <template v-if="drug.drug.commentsbypak">
                <div>
                  <i
                    v-tooltip="{
                        content: drug.drug.commentsbypak,
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        offset: 20,
                        delay: {
                          show: 500,
                          hide: 300
                        }
                      }"
                    class="icon-fa icon-fa-info-circle"
                  ></i>
                </div>
              </template>
              <template v-if="drug.drug.computation_comment">
                <i
                  v-tooltip="{
                      content: drug.drug.computation_comment,
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      offset: 20,
                      delay: {
                        show: 500,
                        hide: 300
                      }
                    }"
                  class="icon-fa icon-fa-home"
                ></i>
              </template>
            </div>
          </div>

        </td>
        <td>{{ order.price }}</td>
        <td>
          {{
            (order.extra_options &&
              order.extra_options.salary) ||
            0
          }}
        </td>
        <td>
          {{
            (
              order.price -
              ((order.extra_options && order.extra_options.salary) ||
                0)
            )
          }}
        </td>
        <td>
          {{ order.address }}
        </td>
        <td>
          {{
            (runners[order.runner_id] &&
              runners[order.runner_id].name) ||
            `не определен (${order.runner_id})`
          }}
        </td>
      </tr>
      <tr class="total_tr">
        <td colspan="4">ИТОГО</td>
        <td>{{ totalFigures.price }}</td>
        <td>{{ totalFigures.salary }}</td>
        <td>{{ totalFigures.pass }}</td>
        <td colspan="10"></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import moment from 'moment';

export default {
  props: [
    'orders',
    'runners'
  ],
  data() {
    return {
      ordersCashDetails: {},
      subStatus_closedByTablet: 8,
      subStatus_rejectedByTablet: 9,
      totalFigures: {
        price: 0,
        salary: 0,
        pass: 0
      }
    }
  },
  computed: {
    $AllCities() {
      return this.$store.getters['platform/cities'];
    },
  },
  created() {
    this.updateTotalFigures();
  },
  methods: {
    moment: function (date, format = "DD.MM.YYYY") {
      if (!date) return;
      return moment(date).format(format);
    },
    updateTotalFigures() {
      this.orders.forEach((o) => {
        this.totalFigures.price += o.price;
        this.totalFigures.salary += o.extra_options.salary || 0;
        this.totalFigures.pass += o.price - ((o.extra_options && o.extra_options.salary) || 0);
      })
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 2px;
}

.icon-fa-credit-card {
  color: black;
}

th {
  white-space: normal !important;
}

.total_tr {
  background-color: #cbffcb !important;
  font-weight: 600;
}

.total_tr td {
  font-size: 16px;
}
</style>
